<template>
  <transition name="modal" v-if="showModal">
    <div class="modal-mask">
      <div :class="{ 'modal-container': true, small: small, tiny: tiny }">
        <div class="modal-header">
          <slot name="header">
            <p class="title is-3" v-if="title">{{ title }}</p>
          </slot>
        </div>

        <div class="modal-body">
          <slot></slot>
        </div>

        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },

    small: {
      type: Boolean,
      default: false,
    },

    tiny: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  watch: {
    showModal(showModal) {
      if (showModal) {
        this.$emit('shown');
      } else {
        this.$emit('hidden');
      }
    },
  },

  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    toggle() {
      this.showModal = !this.showModal;
    },
  },
};
</script>

<style lang="scss" projectd>
@import 'node_modules/bulma/sass/utilities/_all';

.modal-mask {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-container {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  transform: none;
  max-height: inherit;

  @include desktop {
    min-width: 80vw;

    &.small {
      min-width: 70vw;
    }

    &.tiny {
      min-width: 50vw;
    }
  }
  @include widescreen {
    min-width: 80vw;

    &.small {
      min-width: 70vw;
    }

    &.tiny {
      min-width: 50vw;
    }
  }
}

.modal-header {
  padding: 20px;
  background-color: #ecf0f2;
}

.modal-body {
  padding: 20px;
  overflow-y: scroll;
  max-height: 65vh;
}

.modal-footer {
  padding: 20px;
  background: #ecf0f2;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;

  .modal-container {
    transition: transform 0.5s;
  }
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-container {
    transform: scale(0.8);
  }
}
</style>
